import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';


@Injectable()
export class ErrorMapperService {
  constructor() {
  }

  public static generateErrorMessage(operation: string, errors: any): any {
    let error;
    switch (operation) {
      case 'loadSubscription': {
        error = ErrorMapperService.mapLoadSubscriptionError(errors);
        break;
      }
      case 'Enabling profile': {
        error = {message: 'error enabling profile'};
        break;
      }
      case 'Setting fallback': {
        error = {message: 'error setting fallback'};
        break;
      }
      case 'Deleting profile': {
        error = {message: 'error deleting profile'};
        break;
      }
      case 'Saving CardGroup':
      case 'saveCardGroups': {
        error = ErrorMapperService.mapSaveGardGroupError(errors);
        break;
      }
      case 'increasePriority': {
        error = {message: 'error increasing priority'};
        break;
      }
      case 'decreasePriority': {
        error = {message: 'error decreasing priority'};
        break;
      }

      case 'userPermission': {
        error = ErrorMapperService.mapUserPermissionError(errors);
        break;
      }
      default: {
        error = {message: errors};
        break;
      }
    }
    return error;

  }

  private static mapSaveGardGroupError(error): any {
    if (error.url === undefined || error.status === undefined) {
      return {message: error};
    }
    const containsTimers = error.url.indexOf('timers');

    let errorText = 'Error saving MCC tracker settings';

    if (containsTimers !== -1) {
      errorText = 'Error saving timer settings';
    }

    return {message: errorText};

  }

  private static mapLoadSubscriptionError(error): any {
    // ErrorMessage is internal validation, so we return errormessage as it is
    if (error.url === undefined || error.status === undefined) {
      return error;
    }
    const eis = error.url.match('(?<=\/cards\/).*?(?=\/subsc)');
    switch (error.status) {
      case 403: {
        error = {message: 'Not authorized eis(' + eis + ')'};
        break;
      }
      case 400: {
        error = {message: ' The pool has no Perso-Elements eis(' + eis + ')'};
        break;
      }
      case 404: {
        error = {message: 'Unknown Pool eis(' + eis + ')'};
        break;
      }
      case 409: {
        error = {
          message: 'The pool has no available subscriptions for the download or the card is recyclable-pending eis('
            + eis + ')'
        };
        break;
      }
      case 500: {
        error = {message: 'Internal Error eis(' + eis + ')'};
        break;
      }
      default: {
        error = {message: 'Internal Error eis(' + eis + ')'};
        break;
      }
    }
    return error;
  }

  private static mapUserPermissionError(error): any {
    if (error.url === undefined || error.status === undefined) {
      return {message: error};
    } else {
      const objectId = error.url.split('=').pop();
      return {message: objectId};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/error-mapper.service.ts